export const getImagesArray = (product) => {
  if (!product) return ["/assets/images/placeholder.png"];
  if (Array.isArray(product.images) && product.images.length > 0) {
    const resizedImages = product.images.filter((img) =>
      img.includes("_resized.png")
    );
    if (resizedImages.length > 0) {
      return resizedImages;
    }
    return product.images;
  }
  if (product.image) {
    if (product.image.includes("_resized.png")) {
      return [product.image];
    }
    const resizedPath = product.image.replace(/\.png$/, "_resized.png");
    return [resizedPath];
  }
  return ["/assets/images/placeholder.png"];
};

export const preloadImages = (products, limit = 10) => {
  products.slice(0, limit).forEach((product) => {
    const imagesArray = getImagesArray(product);
    if (imagesArray[0]) {
      const img = new window.Image();
      img.src = imagesArray[0];
    }
  });
};
